import { CORE } from "./commonRepository";

/**
 * List of contacts
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const GetAll = async (filter) =>{
    try{
        const result = await CORE.get('v1/contacts', {
            params: filter
        });
        return result;
    }catch(error){
        return error.response;
    }
};

/**
 * Create of contacts
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const Create = async (modal) =>{
    try{
        const result = await CORE.post('v1/contacts', modal);
        return result;
    }catch(error){
        return error.response;
    }
};
